import { each, some } from 'lodash';
import { getHistoryAppId, getHistoryIcon } from '@react/constants/historyEvent';
/**
 * @ngdoc directive
 * @name adjust.accountSettings.directive:audit
 * @scope
 * @restrict E
 *
 * @description
 * Display account history
 *
 */
function audit() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./audit.html'),
    controller: 'AuditController',
    controllerAs: 'vm',
    bindToController: {
      expandable: '=',
      predefinedEvents: '=?',
    },
  };
}

/**
 * @ngdoc controller
 * @name adjust.accountSettings.directive:AuditController
 *
 * @description
 * All the functionality of the {@link adjust.apps.directive:audit audit} directive
 *
 */
function AuditController($scope) {
  'ngInject';
  var vm = this;

  vm.events = vm.predefinedEvents || [];
  vm.anyEventExpanded = false;

  vm.getAppId = getHistoryAppId;
  vm.getChangeType = getChangeType;
  vm.toggle = toggle;

  $scope.$on('audit:reset', _resetEvents);
  $scope.$on('audit:loaded', _renderEvents);

  /**
   * @ngdoc method
   * @name _resetEvents
   * @methodOf adjust.accountSettings.directive:AuditController
   *
   * @description
   * Reset audit events list
   *
   * @private
   */
  function _resetEvents() {
    vm.events = [];
  }

  /**
   * @ngdoc method
   * @name _renderEvents
   * @methodOf adjust.accountSettings.directive:AuditController
   *
   * @description
   * Render audit events
   *
   * @param {Object} e scope event
   * @param {Array|events} events events array
   * @private
   */
  function _renderEvents(e, events) {
    vm.events = vm.events.concat(events);
  }

  /**
   * @ngdoc method
   * @name getChangeType
   * @methodOf adjust.accountSettings.directive:AuditController
   *
   * @description
   * Checks the passed event and return the event type
   *
   * @param {Object} event audit event
   * @returns {string} event type
   * @private
   */
  function getChangeType(event) {
    return getHistoryIcon(event) || 'app';
  }

  /**
   * @ngdoc method
   * @name toggle
   * @methodOf adjust.accountSettings.directive:AuditController
   *
   * @description
   * Toggle visibility of difference
   *
   * @param event
   */
  function toggle(event) {

    if (!vm.expandable) { return; }

    each(vm.events, function(evt) {

      evt.expanded = evt.id === event.id && !evt.expanded;

    });

    vm.anyEventExpanded = some(vm.events, {expanded: true});

  }
}

export { AuditController, audit };
